import * as type from "../../types/API/transporterDetails";
import { IAction } from "../userMetadataReducer";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const getTransporterDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.GET_TRANSPORTER_DETAILS:
      return {
        ...state,
        loading: true,
      };
    case type.GET_TRANSPORTER_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload.responseData,
      };
    case type.GET_TRANSPORTER_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const addTransporterDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.ADD_TRANSPORTER_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.ADD_TRANSPORTER_DETAILS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.ADD_TRANSPORTER_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const editTransporterDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.EDIT_TRANSPORTER_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.EDIT_TRANSPORTER_DETAILS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.EDIT_TRANSPORTER_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const deleteTransporterDetailsReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case type.DELETE_TRANSPORTER_DETAILS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case type.DELETE_TRANSPORTER_DETAILS_SUCCESS:
      return {
        error: null,
        loading: false,
        data: action.payload.responseData,
      };
    case type.DELETE_TRANSPORTER_DETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};
 